/**
 * Marquee Text Module
 * 
 * @package KateMedia
 */

export function initMarquee() {
    const SPEED_PX_PER_SEC = 40; // базовая скорость

    const measureAndAnimate = () => {
        const wrappers = document.querySelectorAll('.service__text-wrapper');
        // Пропускаем, если внутри Swiper
        wrappers.forEach((wrapper) => {
            if (wrapper.closest('.service-overview-swiper')) {
                wrapper.style.animation = 'none';
            }
        });
        wrappers.forEach((wrapper, index) => {
            if (wrapper.closest('.service-overview-swiper')) return;
            const texts = wrapper.querySelectorAll('.service__text');
            if (texts.length === 0) return;

            // Гарантируем две копии для бесшовности
            if (texts.length === 1) {
                wrapper.appendChild(texts[0].cloneNode(true));
            }

            const firstText = wrapper.querySelector('.service__text');
            if (!firstText) return;

            // Точная ширина первого блока текста
            const distance = Math.ceil(firstText.getBoundingClientRect().width);
            wrapper.style.setProperty('--marquee-distance', `${distance}px`);

            // Длительность = расстояние / скорость (с ограничениями)
            const duration = Math.max(15, Math.min(60, distance / SPEED_PX_PER_SEC));

            // Сбрасываем предыдущее состояние, чтобы избежать рывка при перерасчёте
            wrapper.style.animation = 'none';
            // Force reflow
            // eslint-disable-next-line no-unused-expressions
            wrapper.offsetHeight;

            const keyframe = index === 0 ? 'marquee-right' : 'marquee-left';
            wrapper.style.animation = `${keyframe} ${duration}s linear infinite`;
        });
    };

    const initAfterFonts = () => {
        // Первая инициализация
        measureAndAnimate();
        // Обновление при ресайзе
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(measureAndAnimate, 150);
        });
    };

    if ('fonts' in document && document.fonts && document.fonts.ready) {
        document.fonts.ready.then(initAfterFonts).catch(initAfterFonts);
    } else if (document.readyState === 'complete') {
        initAfterFonts();
    } else {
        window.addEventListener('load', initAfterFonts, { once: true });
    }
}
